prepareDB/* eslint-disable */
<template>
  <q-page padding >
    <div class="text-center"><h2>Stock Management</h2></div>
        <div class="q-pa-md row items-start q-gutter-md">
            <q-card class="my-card">
                <q-card-section style="height:145px">
                    <div class="text-h6 text-bold">Generate Stocktake Cart</div>
                    <div>A new stock cart will be created for stocktake purposes, all available items in stock will be added to this cart.<br> On success, you will be redirected to the stock store.</div>
                </q-card-section>
                <q-separator/>
                <q-card-actions  align="center">
                    <q-btn :disable="lock" :color="btnColour" @click="createCart()">Generate</q-btn>
                </q-card-actions>
            </q-card>
            <q-card class="my-card">
                <q-card-section style="height:145px">
                    <div class="text-h6 text-bold">Generate Stocktake Report as CSV</div>
                    <div>A CSV report with stock details is created and downloaded.</div>
                </q-card-section>
                    <q-separator/>
                <q-card-actions  align="center">
                    <q-btn disable color="primary" @click="createCart()">Generate CSV</q-btn>
                </q-card-actions>
            </q-card>
        </div>        
  </q-page>
</template>

<script>
/* eslint-disable */
import gql from 'graphql-tag'
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'StocktakeManagement',
  data (){
      return {
          lock:false,
          btnColour:"primary"
    }
  },
  methods: {
    async createCart(){
        this.lock = true;
        this.btnColour = "black"
        console.log("creting cart")
        let newCartID = await this.$store.dispatch('cart/createNewActiveCart', { input: { name: "Stocktake" + moment().format('DD/MM/YY HH:mm:ss') }, storeType: "stock" })
        await this.$store.dispatch('cart/init');        
        console.log('ID',newCartID);
        await this.generateStocktakeCart_mutation(newCartID)
        this.$router.push(`/stock`)
    },
    async generateStocktakeCart_mutation(cart_id){
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation generateStocktakeCart ($id: ID!) {
            generateStocktakeCart(id: $id)
          }
        `,
          variables: {
            id: cart_id
          }
        })
        console.log("generateStocktakeCart RESULT:",result.data.generateStocktakeCart)
        return result.data.generateStocktakeCart;
      } catch (error) {
        console.log("generateStocktakeCart ERROR",error)
      }      
    }
  }
}
</script>


<style scoped>
 .my-card {
     width:400px;
     height:200px;
}
</style>